var _rect, _path, _rect2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 14,
    fill: "url(#paint0_linear_97_896)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.158 11H25.842C26.6794 11.0005 27.4823 11.3334 28.0745 11.9255C28.6666 12.5177 28.9995 13.3206 29 14.158V17.524C28.9184 17.5188 28.8367 17.5162 28.755 17.516C28.3143 17.5137 27.8788 17.6115 27.4814 17.802C27.084 17.9926 26.7351 18.2709 26.461 18.616C25.989 19.202 25.703 19.993 25.633 20.882C25.6183 21.0593 25.6127 21.2367 25.616 21.414C25.663 23.428 26.751 25.038 28.684 25.038C28.792 25.038 28.8973 25.033 29 25.023V25.843C28.9992 26.6802 28.6662 27.4829 28.0741 28.0748C27.482 28.6667 26.6792 28.9995 25.842 29H14.158C13.3206 28.9995 12.5177 28.6666 11.9255 28.0745C11.3334 27.4823 11.0005 26.6794 11 25.842V14.158C11.0005 13.3206 11.3334 12.5177 11.9255 11.9255C12.5177 11.3334 13.3206 11.0005 14.158 11ZM29 23.388V20.662H27.347C27.273 21.978 27.993 23.092 29 23.388ZM29 20.281V17.973C28.9165 17.9503 28.8305 17.9385 28.744 17.938C27.929 17.955 27.444 18.93 27.384 20.281H29ZM25.697 15.3L25.712 15.297V15.187H22.812L20.122 21.513L17.43 15.187H14.306V15.297L14.32 15.3C14.849 15.42 15.117 15.598 15.117 16.24V23.76C15.117 24.402 14.847 24.58 14.319 24.7L14.305 24.702V24.812H16.425V24.702L16.41 24.7C15.881 24.58 15.612 24.402 15.612 23.76V16.676L19.07 24.813H19.266L22.825 16.449V23.945C22.779 24.453 22.513 24.61 22.034 24.718L22.02 24.721V24.83H25.712V24.72L25.697 24.718C25.217 24.61 24.945 24.453 24.9 23.945L24.897 16.24H24.9C24.9 15.598 25.168 15.42 25.697 15.3Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 13.5,
    stroke: "white",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_97_896",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/Medium.e003757b81f69654d429c62a0f7c1a0b.svg";
export { ForwardRef as ReactComponent };